import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JobCatsOne } from '../vacancy-data.component';

@Injectable({ providedIn: 'root' })
export class JobsNavigationService {
  constructor(private readonly router: Router) {}

  public navigateToJob(job: Pick<JobCatsOne, 'id' | 'title'>): void {
    const slug = (job?.title || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    this.router.navigate(['vacatures', `${slug}-${job.id}`]);
  }

  public getJobLocation(job: Pick<JobCatsOne, 'location'>): string {
    return job?.location?.city || 'Nederland';
  }

  public getJobSalary(job: Pick<JobCatsOne, 'salary'>): string {
    const s = job?.salary;
    if (!s) return '';
    if (s.min && s.max) {
      return `€${s.min.toLocaleString('nl-NL')} - €${s.max.toLocaleString('nl-NL')}`;
    }
    if (s.static) {
      return `€${s.static.toLocaleString('nl-NL')}`;
    }
    return '';
  }
}
